import { Translation } from 'Jsx/global.d';
import { InitOptions } from 'i18next';

export type TranslationKeys = InitOptions['resources'];

export type I18nConfig = {
  defaults: { es: { [key: string]: string }; pt: { [key: string]: string } };
  pageKey: string;
};

/* Guys! this is an improved version of the actual t */
const parseTranslationKeys = (
  translationKeys: Translation[],
  i18nConfig?: I18nConfig,
): TranslationKeys => {
  const resources = {};

  // fill all languages
  translationKeys.forEach(function(translation) {
    resources[translation.language] = {};
  });

  translationKeys.forEach(translation => {
    let defaultKeys = {};

    if (i18nConfig) {
      if (i18nConfig.pageKey === translation.page) {
        defaultKeys = i18nConfig.defaults[translation.language];
      }
    }

    // defaultLanguageKeys['es' | 'pt'] =
    resources[translation.language] = {
      ...resources[translation.language], // ...defaultLanguageKeys['es']
      // ['home']: { ... }
      [translation.page]: {
        ...defaultKeys,
        ...translation.keys.reduce((localeKeys, translationKey) => {
          localeKeys[translationKey.name] = translationKey.value; // ['CALL_TO_ACTION_LEFT_LINK'] = 'Me interesa'
          return localeKeys;
        }, {}),
      },
    };
  });

  return resources;
};

export default parseTranslationKeys;
